import React from 'react';
import { Link } from 'react-router-dom';

class AudienceAnalysisLink extends React.Component {
    render() {
        const { id, entity } = this.props;
            
        return (id ? <Link to={`/audience/${entity}/${id}`} {...this.props} className="link"><span className="fa fa-users audience-analysis-link"></span></Link> : null)
    }
}

export default AudienceAnalysisLink